import "./about.css"

function About(){
    return(
        <div className="about__container">
            <h1>About</h1>
            <p>
            This is a loction based travel recommendation app
            </p>
        </div>
    )
}

export default About